//import React, { useState, useEffect } from 'react';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Check, X, CreditCard, DollarSign, Search } from 'lucide-react';
import { Button } from './button';
import { setVentaData } from '../../utils/ventaTemp'; // ajusta la ruta si es distinta
//Alexis
import MixedPaymentModal from './MixedPaymentModal'; // asegúrate de que la ruta sea correcta
import TicketPrinter from '../../components/TicketPrinter'; // ajusta la ruta si es distinta
import { enviarVentaYPropina } from '../../services/api';
import { TipsModal } from './TipsModal'; // Ajustá la ruta si es distinta
import { lanzarPago } from '../../utils/IntentService'; // ajusta la ruta si es distinta
import API_BASE_URL from '../../Config';



export function PaymentModal({
  showPaymentModal,
  setShowPaymentModal,
  paymentMethod,
  setPaymentMethod,
  totalAmount,
  currentOrder,
  onPaymentSuccess,
  processPayment,
  isProcessingPayment,
  setMostrarTicket,     // ✅ NUEVO
  setIdUltimaVenta      // ✅ NUEVO
}) {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [invoiceOption, setInvoiceOption] = useState('no');
  const [clientCedula, setClientCedula] = useState('');
  const [clientInfo, setClientInfo] = useState(null);
  const [showClientForm, setShowClientForm] = useState(false);
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showPropinaPregunta, setShowPropinaPregunta] = useState(false);
  const clienteRef = useRef(null);
  const [showTipsModal, setShowTipsModal] = useState(false);
  const [yaPreguntoPropina, setYaPreguntoPropina] = useState(false);

  //Alexis
  const [showMixedModal, setShowMixedModal] = useState(false);
useEffect(() => {
  if (paymentStatus === 'approved' && !yaPreguntoPropina) {
    setYaPreguntoPropina(true); // marca que ya pasó por acá

    if (haGuardadoRef.current) return;

    if (paymentMethod === 'cash') {
      handleOmitirPropina(true);
    } else {
      setShowPropinaPregunta(true);
    }
  } else if (paymentStatus === 'rejected') {
    const timer = setTimeout(() => {
      setShowPaymentModal(false);
      setPaymentStatus(null);
    }, 3000);
    return () => clearTimeout(timer);
  }
  }, [paymentStatus, paymentMethod, yaPreguntoPropina]);


  const handleProcessPayment = async () => {
    //const result = await processPayment();
    const result = true;
    setPaymentStatus(result ? 'approved' : 'rejected');
  };

  const handleConfirmPropina = () => {
    setShowPropinaPregunta(false);
    setShowTipsModal(true); // ✅ Muestra TipsModal
  };


  const haGuardadoRef = useRef(false);

  //const handleOmitirPropina = (redirigir = false) => {
  const handleOmitirPropina = async (redirigir = false) => {

    if (haGuardadoRef.current) return;
    haGuardadoRef.current = true;
    setShowPropinaPregunta(false);
    setShowSuccessMessage(true);

    if (paymentMethod === 'card') {
      console.log('👉 Disparando intent de pago con tarjeta desde Omitir...');
      try {
        const pagoResult = await lanzarPago({
          amountBuy: totalAmount.toString(),
          amountChange: '0',
          currencyCode: '600',
          printVoucher: 'true',
          promotions: '',
          providerId: '0001'
        });
        console.log('💳 Resultado del intent:', pagoResult);
      } catch (error) {
        console.error('⛔ Error al lanzar el intent de pago:', error);
      }
    }


    ///Alexis cambios
    

    setTimeout(async () => {
      
      if (paymentMethod === 'card') {
        console.log('👉 Disparando intent de pago con tarjeta desde Omitir...');
        const pagoResult = await lanzarPago({
          amountBuy: String(totalAmount),  // Asegúrate de convertir bien aquí
          amountChange: '0',
          currencyCode: '600',
          printVoucher: 'true',
          promotions: '',
          providerId: '0001'
        });

        console.log('Resultado del intent:', pagoResult);

        if (!pagoResult || pagoResult.responseCode !== '00') {
          console.warn('⛔ Pago con tarjeta rechazado en POS.');
          setShowPaymentModal(false);
          setShowSuccessMessage(false);
          //haGuardadoRef.current = false;
          return;
        }
      }


//----

      
      if (paymentStatus !== 'approved') {
        console.warn('⛔ No se puede guardar la venta: pago no aprobado.');
        setShowPaymentModal(false);
        setShowSuccessMessage(false);
        return;
      }

      const fechaActual = new Date().toISOString();
      const cliente = invoiceOption === 'no'
        ? { nombre: 'Cliente sin Nombre', ci: '0', digitoVerificador: '0' }
        : clienteRef.current;

      const ventaData = {
        fecha: fechaActual,
        total: totalAmount,
        metodoPago: paymentMethod,
        registerProcess: cliente?.ci || '0',
        cliente,
        productos: currentOrder?.items.map(item => ({
          id: item.productId,
          nombre: item.productName,
          precio: item.price,
          cantidad: item.quantity
        })) || []
      };

      setVentaData(ventaData);

      try {
        const result = await enviarVentaYPropina(ventaData);
        console.log("📄 Resultado recibido:", result);
        const ventaId = result?.id;
        if (ventaId) {
          if (redirigir) {
            setIdUltimaVenta(ventaId);
            setMostrarTicket(true);
          } else {
            setIdUltimaVenta(ventaId);
            setMostrarTicket(true);
            onPaymentSuccess?.({ deseaDejarPropina: false });
          }
        }
        else {
          console.error('❌ La venta fue enviada pero no se recibió el ID');
        }
      } catch (error) {
        console.error('❌ Error al guardar venta sin propina:', error);
      } finally {
        setShowPaymentModal(false);
        setShowSuccessMessage(false);
        resetForm();
      }
    }, 3000);
  };


  const resetForm = () => {
    haGuardadoRef.current = false;
    setYaPreguntoPropina(false); // ⚠️ necesario
    setPaymentStatus(null);
    setClientCedula('');
    setClientInfo(null);
    setShowClientForm(false);
    setNombre('');
    setApellido('');
  };
// esto permanece igual
  const handleBuscarCliente = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/register-process/buscar/${clientCedula}`);
      if (res.ok) {
        const data = await res.json();
        //setClientInfo(`Nombre= ${data.nombre}. CI= ${data.ci}`);
        setClientInfo(`Nombre= ${data.nombre}. CI= ${data.ci}`);
        clienteRef.current = data;
        setShowClientForm(false);
      } else {
        setClientInfo('Cliente no encontrado');
        setShowClientForm(true);
      }
    } catch (error) {
      console.error('Error buscando cliente:', error);
      setClientInfo('Error al buscar cliente');
    }
  };

  const handleAgregarCliente = async () => {
    if (nombre.trim() && apellido.trim() && clientCedula.trim()) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/register-process`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nombre: `${nombre} ${apellido}`,
            ci: clientCedula,
            digitoVerificador: 0
          })
        });

        if (response.ok) {
          alert('✅ Cliente agregado correctamente');
          setClientInfo(`Nombre= ${nombre}. CI= ${clientCedula}`);
          clienteRef.current = {
            nombre: `${nombre} ${apellido}`,
            ci: clientCedula,
            digitoVerificador: '0'
          };
          setShowClientForm(false);
        } else {
          alert('❌ No se pudo agregar el cliente');
        }
      } catch (error) {
        console.error('Error al agregar cliente:', error);
      }
    }
  };

  if (!showPaymentModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        {showSuccessMessage ? (
          <div className="text-center py-4">
            <Check className="h-16 w-16 text-green-500 mx-auto mb-2" />
            <h3 className="font-bold text-lg text-green-500">Pago Aceptado</h3>
            <p className="text-gray-600">El pago se ha procesado correctamente</p>
          </div>
        ) : showPropinaPregunta ? (
          <div className="text-center py-4">
            <h3 className="font-bold text-lg mb-4">¿Desea dejar una propina al mozo?</h3>
            <div className="flex justify-center gap-4 mt-4">
              <Button className="bg-green-600 text-white" onClick={() => {
                setShowPropinaPregunta(false);
                setShowTipsModal(true); // ✅ ahora sí se muestra el modal de propina
              }}>
                Sí
              </Button>
              <Button variant="outline" onClick={() => handleOmitirPropina(false)}>
                Omitir
              </Button>
            </div>
          </div>
        ) : !paymentStatus ? (
          <>
            <h3 className="font-bold text-lg mb-4">Seleccionar método de pago</h3>
            <div className="space-y-3">
              <Button
                className={`w-full ${paymentMethod === 'cash' ? 'bg-green-500' : ''}`}
                onClick={() => setPaymentMethod('cash')}
              >
                <DollarSign className="mr-2" />
                Efectivo
              </Button>
              <Button
                className={`w-full ${paymentMethod === 'card' ? 'bg-green-500' : ''}`}
                onClick={() => setPaymentMethod('card')}
              >
                <CreditCard className="mr-2" />
                Tarjeta
              </Button>

              {/*Alexis*/}

              <Button
                className="w-full bg-yellow-500 text-white"
                onClick={() => {
                  const cliente = invoiceOption === 'no'
                    ? { nombre: 'Cliente sin Nombre', ci: '0', digitoVerificador: '0' }
                    : clienteRef.current;

                  const fechaActual = new Date().toISOString();

                  setVentaData({
                    mesa: currentOrder?.name || 'sin_mesa',
                    productos: currentOrder?.items.map(item => ({
                      id: item.productId,
                      nombre: item.productName,
                      precio: item.price,
                      cantidad: item.quantity
                    })) || [],
                    total: totalAmount,
                    metodoPago: 'MIXTO',
                    cliente,
                    fecha: fechaActual,
                    registerProcess: cliente?.ci || '0',
                  });

                  setShowMixedModal(true);
                }}
              >
                Pago Mixto
              </Button>
            </div>

            <div className="mt-4">
              <p className="font-medium mb-2">¿Desea factura?</p>
              <div className="flex gap-4">
                <label className="flex items-center gap-1 text-sm">
                  <input
                    type="radio"
                    value="yes"
                    checked={invoiceOption === 'yes'}
                    onChange={() => setInvoiceOption('yes')}
                  />
                  Con factura
                </label>
                <label className="flex items-center gap-1 text-sm">
                  <input
                    type="radio"
                    value="no"
                    checked={invoiceOption === 'no'}
                    onChange={() => setInvoiceOption('no')}
                  />
                  Sin factura
                </label>
              </div>
            </div>

            {invoiceOption === 'yes' && (
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Cédula del Cliente
                </label>
                <input
                  type="text"
                  value={clientCedula}
                  onChange={(e) => setClientCedula(e.target.value)}
                  placeholder="Ej: 1234567"
                  className="w-full px-3 py-2 border rounded-md text-sm"
                />
                <div className="flex justify-end mt-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleBuscarCliente}
                    className="flex items-center gap-1"
                  >
                    <Search className="w-4 h-4" />
                    Buscar Cliente
                  </Button>
                </div>

                {clientInfo && (
                  <>
                    <p className="text-sm mt-2 text-center text-gray-600">{clientInfo}</p>
                    {showClientForm && (
                      <div className="mt-4 space-y-2">
                        <input
                          type="text"
                          placeholder="Nombre"
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          value={nombre}
                          onChange={(e) => setNombre(e.target.value)}
                        />
                        <input
                          type="text"
                          placeholder="Apellido"
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          value={apellido}
                          onChange={(e) => setApellido(e.target.value)}
                        />
                        <input
                          type="text"
                          placeholder="CI"
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          value={clientCedula}
                          onChange={(e) => setClientCedula(e.target.value)}
                        />
                        <Button
                          className="w-full bg-blue-600 text-white"
                          onClick={handleAgregarCliente}
                        >
                          Agregar Cliente
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            <div className="mt-4 flex justify-between">
              <Button variant="outline" onClick={() => setShowPaymentModal(false)}>
                Cancelar
              </Button>
              <Button
                disabled={
                  !paymentMethod ||
                  isProcessingPayment ||
                  (invoiceOption === 'yes' && !clientCedula.trim())
                }
                onClick={handleProcessPayment}
              >
                {isProcessingPayment ? 'Procesando...' : `Seguir con el pago ($${totalAmount.toFixed(2)})`}
              </Button>
            </div>
          </>
        ) : (
          <div className="text-center py-4">
            <X className="h-16 w-16 text-red-500 mx-auto mb-2" />
            <h3 className="font-bold text-lg text-red-500">Pago Rechazado</h3>
            <p className="text-gray-600">El pago no pudo ser procesado</p>
          </div>
        )}
      </div>

      {/* Modal de Pago Mixto */}
      {showMixedModal && (
        <MixedPaymentModal
  onClose={() => setShowMixedModal(false)}
  onPaymentSuccess={({ ventaId }) => {
    setShowMixedModal(false);
    setShowPaymentModal(false);
    setIdUltimaVenta(ventaId);    // 👈 guarda el ID en MainPOSLayout
    setMostrarTicket(true); 
          }}
        />
      )}

      {/* Modal de Propina */}
      {showTipsModal && (
        <TipsModal
          showTipsModal={showTipsModal}
          setShowTipsModal={setShowTipsModal}
          totalAmount={totalAmount}
          currentOrder={currentOrder}
          onConfirm={(data) => {
            onPaymentSuccess?.({ deseaDejarPropina: true, ...data });
            setShowTipsModal(false);
            setShowPaymentModal(false); // ✅ también cerramos el modal principal
          }}
          onCancel={() => {
            // 🔄 Reiniciar al paso anterior
            setShowPropinaPregunta(true);
          }}
        />
      )}
    </div>
  );
}